import React from 'react';
import EyeFilledIcon from '../../assets/icons/EyeFilledIcon';

/**
 * Persistent informational banner shown at the bottom of the screen when the
 * authenticated user has read-only access to the current module.
 *
 * Rendered automatically by ProtectedRoute — no manual placement needed.
 */
const ReadOnlyBanner = () => (
  <div className="fixed bottom-0 left-0 right-0 z-40 bg-surface-subtle border-t border-neutral-40 flex items-center justify-end gap-2 px-8 py-4">
    <EyeFilledIcon
      width={16}
      height={16}
      stroke="#48486B"
      strokeWidth={1.25}
      className="shrink-0"
    />
    <p className="text-body-2 text-neutral-80 m-0">
      <span className="font-bold">Modo de solo lectura.</span>
      {' Contacta al administrador para modificar este módulo.'}
    </p>
  </div>
);

export default ReadOnlyBanner;
